import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const CropSelectionDropdown = ({
  selectedPlantId,
  selectedPlantName,
  handlePlantSelection,
  loadingOptions,
  cropOptions,
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ width: "100%", maxWidth: 300 }}>
      <FormControl fullWidth size="small">
        <InputLabel id="plant-select-label">
          {t("Select Plant Type")}
        </InputLabel>
        <Select
          labelId="plant-select-label"
          id="plant-select"
          value={selectedPlantId}
          label={t("Select Plant Type")}
          onChange={handlePlantSelection}
          disabled={loadingOptions || cropOptions.length === 0}
        >
          {loadingOptions ? (
            <MenuItem value="">
              <em>{t("Loading options...")}</em>
            </MenuItem>
          ) : (
            cropOptions.map((crop) => (
              <MenuItem key={crop.id} value={crop.id.toString()}>
                {crop.name}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
      {selectedPlantName && (
        <Typography
          variant="body2"
          color="primary"
          sx={{ mt: 1, fontStyle: "italic", textAlign: "center" }}
        >
          {t("Selected")}: {selectedPlantName}
        </Typography>
      )}
    </Box>
  );
};

export default CropSelectionDropdown;
